import makeRequest from '../utils/makeRequest';

const baseExtrasUrl = '/partners';

export const getPartners = async () =>
  makeRequest({
    method: 'get',
    url: `${baseExtrasUrl}`,
  });
